import { useEffect, useState } from "react";
import AssignTerritories from "./assignTerritories";
import Hierarchy from "./hierarchy";
import Rules from "./rules";
import { getItem } from "../../../Services/localService";
import { useDispatch, useSelector } from "react-redux";
import { createTerritoryStart, deleteTerritoryStart, getTerritoryStart, updateTerritoryStart } from "../../../Store/Slices/territorySlice";
import Loader from "../../../Components/Loader";
import { FiSearch } from "react-icons/fi";

const Territories = () => {
    const dispatch = useDispatch()
    let currentUser = getItem("user")
    let allUsers = useSelector((state) => state?.user)?.allUserData
    let territoryData = useSelector((state) => state?.territory)
    let territoryList = useSelector((state) => state?.territory)?.territoryList;
    let [isShowNewCreationUI, setIsShowNewCreationUI] = useState(false)
    let [createTerritoryFrom, setCreateTerritoryFrom] = useState('')
    let [isCreate, setIsCreate] = useState(true)
    let [showTreeNode, setShowTreeNode] = useState(true);

    let created = false;

    useEffect(() => {
        dispatch(getTerritoryStart())
    }, [])

    useEffect(() => {
        // if (territoryData?.territoryList?.length > 0) {
        //     for (var i = 0; i < territoryData?.territoryList.length; i++) {
        //         // if (i !== 0) {
        //         dispatch(deleteTerritoryStart(territoryData?.territoryList[i]._id))
        //         // }
        //     }
        // }
        if (!territoryData?.territoryList || territoryData?.territoryList?.length === 0 && !created) {
            // debugger
            if (allUsers && allUsers.length) {
                const user = allUsers.find(obj => obj.role.role_name === 'CEO');
                if (user) {
                    let payload = {
                        territory_name: currentUser?.organization?.organizationName,
                        description: 'Organization Parent Territory',
                        territory_manager: {
                            name: `${user?.firstName} ${user?.lastName}`,
                            id: user?._id
                        },
                        parent_territory: null,
                        permission_type: 'read-only'
                    }
                    // debugger
                    dispatch(createTerritoryStart(payload))
                    created = true;
                }
            }
        }
    }, [])

    useEffect(() => {
        // debugger
        if (territoryData?.createStatus || territoryData?.deleteStatus || territoryData?.updateStatus) {
            dispatch(getTerritoryStart())
        }
    }, [territoryData?.createStatus, territoryData?.deleteStatus, territoryData?.updateStatus])

    const handleSubmit = (payload) => {
        setCreateTerritoryFrom('')
        setIsShowNewCreationUI(false)
        dispatch(createTerritoryStart(payload))
    }

    const handleUpdate = (id, payload) => {
        setCreateTerritoryFrom('')
        setIsShowNewCreationUI(false)
        setIsCreate(true)
        dispatch(updateTerritoryStart({ id: id, payload: payload }))
    }

    const handleDeleteTerritory = (data) => {
        dispatch(deleteTerritoryStart(data?._id))
    }

    const handleRemoveTerritoryManager = (data) => {
        const payload = {
            ...data,
            territory_manager: null
        };
        dispatch(updateTerritoryStart({ id: data?._id, payload: payload }))
    }

    const handleChangeTerritoryManager = (data, obj) => {
        const payload = {
            ...data,
            territory_manager: obj
        };
        dispatch(updateTerritoryStart({ id: data?._id, payload: payload }))
    }

    const collapseAll = () => {
        setShowTreeNode(!showTreeNode);
    }

    const updateRule = (value, data) => {
        const payload = {
            ...data,
            account_rule: value.conditions
        };
        dispatch(updateTerritoryStart({ id: data?._id, payload: payload }))
    }

    return (
        <>
            <Loader isVisible={territoryData?.isLoading} />
            <div className="g-settings security-ctrl role-sharing h-100">
                <div className="card rounded-0 border-0 p-0 h-100">
                    {/* Tabs Header Section */}
                    <div className="card-header py-0 fs-14 bg-white rounded-top-4">
                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                            <li className="nav-item px-3" role="presentation">
                                <button className="nav-link text-primary position-relative px-0 active" id="pills-tab-1"
                                    data-bs-toggle="pill" data-bs-target="#pills-tab1" type="button" role="tab"
                                    aria-controls="pills-tab1" aria-selected="true">Territories</button>
                            </li>
                            <li className="nav-item px-3" role="presentation">
                                <button className="nav-link text-primary position-relative px-0" id="pills-tab-2"
                                    data-bs-toggle="pill" data-bs-target="#pills-tab2" type="button" role="tab"
                                    aria-controls="pills-tab2" aria-selected="false">Territory Rules</button>
                            </li>
                            <li className="nav-item px-3" role="presentation">
                                <button className="nav-link text-primary position-relative px-0" id="pills-tab-3"
                                    data-bs-toggle="pill" data-bs-target="#pills-tab3" type="button" role="tab"
                                    aria-controls="pills-tab3" aria-selected="false">Assign Territories</button>
                            </li>
                        </ul>
                    </div>
                    {/* // Tabs Header Section END // */}

                    <div className="card-body overflow-y-auto pt-0">
                        <div className="tab-content px-3" id="pills-tabContent">
                            {/* Hierarchy Tab */}
                            <div className="tab-pane fade show active" id="pills-tab1" role="tabpanel" aria-labelledby="pills-tab-1">
                                {/* <div className={`roles ${showRolesList ? 'd-block' : 'd-none'}`}> */}
                                <div className="roles">
                                    {!isShowNewCreationUI &&
                                        <>
                                            <div className="pt-4">
                                                <h5 className="fw-semibold">Territory Hierarchy</h5>
                                                {/* <p className="w-75">
                                            This page will allow you to define how you share the data among users based
                                            on your organization's role hierarchy. For more information, refer to online help.
                                        </p> */}
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between py-4">
                                                <div className="d-flex align-items-start">
                                                    <div className="search-box border rounded-2">
                                                        <label htmlFor="userSearch" className="searchbutton bg-white" type="button">
                                                            <FiSearch />
                                                        </label>
                                                        <input type="search" placeholder="Search" id="userSearch" className="searchfield bg-white" defaultValue="" />
                                                    </div>
                                                    <div className="d-flex align-items-center ms-1">
                                                        {/* <button type="button" className="btn btn-link text-decoration-none me-0"
                                                    onClick={expandseAll}
                                                >
                                                    Expand All
                                                </button> */}
                                                        {/* <span className="vr align-self-center"></span> */}
                                                        <button type="button" className="btn btn-link text-decoration-none"
                                                            style={{
                                                                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                                                            }}
                                                            onClick={collapseAll}
                                                        >
                                                            {showTreeNode ? 'Collapse All' : 'Expand All'}
                                                        </button>
                                                    </div>
                                                </div>
                                                <button type="button" className="btn btn-primary btn-blue"
                                                    onClick={() => { setIsCreate(true); setCreateTerritoryFrom('null'); setIsShowNewCreationUI(true) }}>Create New Territory</button>
                                            </div>
                                        </>
                                    }
                                    <Hierarchy isShowNewCreationUI={isShowNewCreationUI} setIsShowNewCreationUI={setIsShowNewCreationUI}
                                        handleSubmit={handleSubmit} createTerritoryFrom={createTerritoryFrom}
                                        setCreateTerritoryFrom={setCreateTerritoryFrom}
                                        isCreate={isCreate} setIsCreate={setIsCreate} handleDeleteTerritory={handleDeleteTerritory}
                                        handleUpdate={handleUpdate} handleRemoveTerritoryManager={handleRemoveTerritoryManager}
                                        handleChangeTerritoryManager={handleChangeTerritoryManager}
                                        showTreeNode={showTreeNode} />
                                </div>
                            </div>
                            {/* // Hierarchy Tab END // */}

                            {/* Rules Tab Start*/}
                            <div className="tab-pane fade" id="pills-tab2" role="tabpanel" aria-labelledby="pills-tab-2">
                                <div className="roles">
                                    <div className="pt-4">
                                        <h5 className="fw-semibold">Territory Rules</h5>
                                        {/* <p className="w-75">
                                            This page will allow you to define how you share the data among users based
                                            on your organization's role hierarchy. For more information, refer to online help.
                                        </p> */}
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between py-4">
                                        <div className="d-flex align-items-start">
                                            <div className="search-box border rounded-2">
                                                <label htmlFor="userSearch" className="searchbutton bg-white" type="button">
                                                    <FiSearch />
                                                </label>
                                                <input type="search" placeholder="Search" id="userSearch" className="searchfield bg-white" defaultValue="" />
                                            </div>
                                            <div className="d-flex align-items-center ms-1">
                                                {/* <button type="button" className="btn btn-link text-decoration-none me-0"
                                                    onClick={expandseAll}
                                                >
                                                    Expand All
                                                </button> */}
                                                {/* <span className="vr align-self-center"></span> */}
                                                <button type="button" className="btn btn-link text-decoration-none"
                                                    style={{
                                                        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                                                    }}
                                                    onClick={collapseAll}
                                                >
                                                    {showTreeNode ? 'Collapse All' : 'Expand All'}
                                                </button>
                                            </div>
                                        </div>
                                        {/* <button type="button" className="btn btn-primary btn-digy-dark rounded-pill py-1 px-3" data-bs-toggle="modal" data-bs-target="#addEditUserModal">Create New Territory</button> */}
                                    </div>
                                    <Rules territoryList={territoryList} showTreeNode={showTreeNode} updateRule={updateRule} />
                                </div>
                            </div>
                            {/* Rules Tab End */}

                            {/* Assign Tab Start*/}
                            <div className="tab-pane fade" id="pills-tab3" role="tabpanel" aria-labelledby="pills-tab-3">
                                <div className="roles">
                                    <div className="pt-4">
                                        <h5 className="fw-semibold">Assign Territories</h5>
                                        <p className="w-75">
                                            Assign or reassign the territories to the Accounts using the Run Rule option. Search your Accounts as needed and run rules for them.
                                        </p>
                                    </div>
                                    <AssignTerritories />
                                </div>
                            </div>
                            {/* Assign Tab End */}
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default Territories;